var exports = {
  "k": "x43aef4ae--fb3748--container",
};

module.exports = exports;
